// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RenameBuilderDiagramMutationVariables = Types.Exact<{
  input: Types.RenameDiagramArtifactInput;
}>;


export type RenameBuilderDiagramMutation = { __typename?: 'Mutation', renameDiagramArtifact: { __typename?: 'DiagramArtifact', id: string, name: string, updatedAt: Time } };

export const Operations = {
  Mutation: {
    RenameBuilderDiagram: 'RenameBuilderDiagram' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const RenameBuilderDiagramDocument = gql`
    mutation RenameBuilderDiagram($input: RenameDiagramArtifactInput!) {
  renameDiagramArtifact(input: $input) {
    id
    name
    updatedAt
  }
}
    `;
export type RenameBuilderDiagramMutationFn = Apollo.MutationFunction<RenameBuilderDiagramMutation, RenameBuilderDiagramMutationVariables>;

/**
 * __useRenameBuilderDiagramMutation__
 *
 * To run a mutation, you first call `useRenameBuilderDiagramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameBuilderDiagramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameBuilderDiagramMutation, { data, loading, error }] = useRenameBuilderDiagramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameBuilderDiagramMutation(baseOptions?: Apollo.MutationHookOptions<RenameBuilderDiagramMutation, RenameBuilderDiagramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameBuilderDiagramMutation, RenameBuilderDiagramMutationVariables>(RenameBuilderDiagramDocument, options);
      }
export type RenameBuilderDiagramMutationHookResult = ReturnType<typeof useRenameBuilderDiagramMutation>;
export type RenameBuilderDiagramMutationResult = Apollo.MutationResult<RenameBuilderDiagramMutation>;
export type RenameBuilderDiagramMutationOptions = Apollo.BaseMutationOptions<RenameBuilderDiagramMutation, RenameBuilderDiagramMutationVariables>;